/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
/* istanbul ignore file */
import { createBrowserHistory } from 'history';

export const history = createBrowserHistory();
